// extracted by mini-css-extract-plugin
export default {"input":"tabsInput_input__rKG2a","formGroup":"tabsInput_formGroup__DxntD"};